<!-- Toolbar -->
<mat-toolbar class="main-toolbar">
    <div class="container toolbar-content">
        <div>
            <img class="logo" src="./assets/images/logo_aqrb.png"
                alt="AQRB Logo" />
        </div>
        <nav class="nav-menu">
            <!-- <a mat-button href="#resources" class="nav-link">Resources</a> -->
            <a mat-button (click)="openEvent()" class="nav-link">Event</a>
            <a mat-button (click)="openLoginModal()" class="nav-link">Login</a>
        </nav>
        <button mat-icon-button class="mobile-menu-toggle"
            (click)="toggleMobileMenu()">
            <mat-icon>menu</mat-icon>
        </button>
    </div>
</mat-toolbar>

<!-- Sidenav Container with Wrapper -->
<div class="sidenav-wrapper">
    <mat-sidenav-container>
        <mat-sidenav #sidenav mode="over" [(opened)]="mobileMenuOpen"
            class="mobile-menu-panel">
            <nav class="mobile-nav">
                <a mat-button href="/app" (click)="sidenav.close()"
                    class="mobile-nav-link">
                    <mat-icon>home</mat-icon>
                    Home
                </a>
                <a mat-button href="#/registration" (click)="sidenav.close()"
                    class="mobile-nav-link">
                    <mat-icon>assignment</mat-icon>
                    Registration
                </a>
            </nav>
        </mat-sidenav>
        <!-- Main Content -->
        <div class="main-content">
            <!-- Hero Section -->
            <section id="home" class="hero-section">
                <div class="container">
                    <div class="row">
                        <div class="col-md-12 text-center my-2">
                            <div class="hero-text d-flex justify-between">
                                <div></div>
                                <h2 class="hero-title">
                                    <span class="title-line-1">{{ title }}</span>
                                </h2>
                                <button mat-icon-button aria-label="Back" routerLink="/">
                                    <mat-icon>arrow_back</mat-icon>
                                </button>

                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <app-data-table [columnHeader]="tableColumns"
                                [tableData$]="firmData$"
                                [pageLength]="pageLengths"
                                [pageIndex]="pageIndexs"
                                (pageChanged)="onPageChanged($event)">
                                <ng-template let-data="data">

                                    <!-- <div class="action-icons">

                                        <button mat-icon-button
                                            [matMenuTriggerFor]="menu"
                                            matTooltip="Actions">
                                            <mat-icon>more_vert</mat-icon>
                                        </button>
                                        <mat-menu #menu="matMenu">
                                            <button mat-menu-item
                                                >
                                                <mat-icon>visibility</mat-icon>
                                                <span>View Bill</span>
                                            </button>
                                        </mat-menu>
                                    </div> -->
                                </ng-template>
                            </app-data-table>
                        </div>

                    </div>

                </div>
            </section>

            <!-- Footer -->
            <footer class="main-footer">
                <div class="container footer-content-wrapper">
                    <div class="footer-header">
                        <h2 class="footer-title">Reach Us</h2>
                        <mat-divider class="footer-divider"></mat-divider>
                    </div>
                    <div class="contact-grid">
                        <mat-card class="contact-card" appearance="outlined">
                            <div class="contact-icon-wrapper location-icon-bg">
                                <mat-icon>location_on</mat-icon>
                            </div>
                            <div class="contact-content">
                                <h3 class="contact-title">Our Location</h3>
                                <address class="contact-address">
                                    <strong>ARCHITECTS AND QUANTITY SURVEYORS
                                        REGISTRATION BOARD</strong><br />
                                    Head Office, 9 AQRB street,<br />
                                    P. O Box 237741101 Tambukareli,<br />
                                    Dodoma, Tanzania
                                </address>
                            </div>
                        </mat-card>
                        <mat-card class="contact-card" appearance="outlined">
                            <div
                                class="contact-icon-wrapper contact-info-icon-bg">
                                <mat-icon>contact_mail</mat-icon>
                            </div>
                            <div class="contact-content">
                                <h3 class="contact-title">Contact
                                    Information</h3>
                                <div class="contact-details">
                                    <div class="contact-item">
                                        <mat-icon
                                            class="contact-icon">email</mat-icon>
                                        <a href="mailto:info@aqrb.go.tz"
                                            mat-button class="contact-link">
                                            info@aqrb.go.tz
                                        </a>
                                    </div>
                                    <div class="contact-item">
                                        <mat-icon
                                            class="contact-icon">phone</mat-icon>
                                        <a href="tel:+255262160370" mat-button
                                            class="contact-link">
                                            +255 26 216 0370/1
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </mat-card>
                    </div>
                </div>
                <mat-toolbar class="copyright-bar">
                    <div class="container copyright-content">
                        <span class="copyright-text">
                            © 2026 All Rights Reserved ARCHITECTS AND QUANTITY
                            SURVEYORS REGISTRATION BOARD
                        </span>
                        <span class="developer-credit">
                            Designed and developed by
                            <img class="developer-logo"
                                src="./assets/images/ega.png" alt="eGA Logo" />
                        </span>
                    </div>
                </mat-toolbar>
            </footer>
        </div>
    </mat-sidenav-container>
</div>